import Vue from 'vue'
import Router from 'vue-router'

// import home from '@/components/home'



Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('@/view/home'),
            meta: {
                navShow: true,
            }
        },
        {
            path: '/qukuailian',
            name: 'qukuailian',
            component: () => import('@/view/qukuailian/qukuailian.vue'),
            meta: {
                navShow: true,
            }
        },
        {
            path: '/cangpin',
            name: 'cangpin',
            component: () => import('@/view/cangpin/cangpin.vue'),
            meta: {
                navShow: true,
            }
        },
        {
            path: '/jishuyoushi',
            name: 'jishuyoushi',
            component: () => import('@/view/jishuyoushi/jishuyoushi.vue'),
            meta: {
                navShow: true,
            }
        },
        {
            path: '/QukuailianYingYong',
            name: 'QukuailianYingYong',
            component: () => import('@/view/QukuailianYingYong/QukuailianYingYong.vue'),
            meta: {
                navShow: true,
            }
        },
        {
            path: '/jiejuefangan',
            name: 'jiejuefangan',
            component: () => import('@/view/QukuailianYingYong/jiejuefangan.vue'),
            meta: {
                navShow: true,
            }
        },


        {
            path: '/youzhifuwu',
            name: 'youzhifuwu',
            component: () => import('@/view/youzhifuwu/youzhifuwu.vue'),
            meta: {
                navShow: true,
            }
        },

        {
            path: '/ulamrongyu',
            name: 'ulamrongyu',
            component: () => import('@/view/ulamrongyu/ulamrongyu.vue'),
            meta: {
                navShow: true,
            }
        },

        {
            path: '/guanyuwomen',
            name: 'guanyuwomen',
            component: () => import('@/view/guanyuwomen/guanyuwomen.vue'),
            meta: {
                navShow: true,
            }
        },
      {
        path: '/suyuan',
        name: 'suyuan',
        component: () => import('@/view/suyuan/index.vue'),
        meta: {
          navShow: true,
        }
      },
      {
        path: '/tonggou',
        name: 'tonggou',
        component: () => import('@/view/tongGou/index.vue'),
        meta: {
          navShow: true,
        }
      },
      {
        path: '/zhaiquan',
        name: 'zhaiquan',
        component: () => import('@/view/zhaiQuan/index.vue'),
        meta: {
          navShow: true,
        }
      },


    ]
})


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js